// extracted by mini-css-extract-plugin
export default {"banner":"Carousel_banner__agKhj","justifyCenter":"Carousel_justifyCenter__LTYpf"};